"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_settings_storefront_html_1 = __importDefault(require("./admin-settings-storefront.html"));
var admin_settings_storefront_controller_1 = __importDefault(require("./admin-settings-storefront.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.settings.policies.storefront", {
        url: "/storefront",
        controller: admin_settings_storefront_controller_1.default,
        controllerAs: "vm",
        template: admin_settings_storefront_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.administrator,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.settings.policies.storefront", [])
    .config(config)
    .controller("AdminSettingsPoliciesStorefrontController", admin_settings_storefront_controller_1.default);
